var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Actions"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.10808 4.13668C4.32708 3.91633 4.68323 3.91524 4.90358 4.13424L9.00559 8.21117L13.1629 4.19059C13.3862 3.97462 13.7423 3.98057 13.9582 4.20388C14.1742 4.42719 14.1683 4.7833 13.9449 4.99927L9.80368 9.00437L13.8899 13.0656C14.1103 13.2846 14.1113 13.6408 13.8924 13.8611C13.6734 14.0814 13.3172 14.0825 13.0969 13.8635L8.99484 9.78662L4.83758 13.8072C4.61427 14.0232 4.25816 14.0172 4.04219 13.7939C3.82623 13.5706 3.83218 13.2145 4.05549 12.9985L8.19675 8.99341L4.11052 4.93217C3.89018 4.71317 3.88909 4.35702 4.10808 4.13668Z",
    fill: "#454F5B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.d04ca429d47b3dc30d066488ad76d0b8.svg";
export { ForwardRef as ReactComponent };